import { Button } from '@material-ui/core';
import { EmptyState } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import { DATABASE_TYPE, routes } from '../../lib/viva';
import { EntityArgoAppsCell } from './cells';
import { datastoreColumns } from './columns';
import { TypedCatalogPage } from './TypedCatalogPage';

const columns = datastoreColumns<CatalogTableRow>('База данных', row => (
  <EntityArgoAppsCell entity={row.entity} />
));

export const DatabasesPage = () => (
  <TypedCatalogPage
    section="databases"
    title="PostgreSQL"
    subtitle="PostgreSQL в кластерах платформы: оператор CloudNativePG, состояние в ArgoCD"
    kind="resource"
    type={DATABASE_TYPE}
    columns={columns}
    create={{ title: 'Создать кластер PostgreSQL', to: routes.newPostgres }}
    support="База создаётся шаблоном «Кластер PostgreSQL»: values попадают в viva/gitops (datastores/<кластер>/…), ArgoCD выбранного кластера разворачивает её, метрики уходят в Prometheus, дашборды — в Grafana."
    emptyContent={
      <EmptyState
        missing="data"
        title="Кластеров PostgreSQL пока нет"
        description="Создайте PostgreSQL из шаблона — оператор в кластере поднимет его, а запись появится здесь после регистрации в каталоге."
        action={
          <Button variant="contained" color="primary" href={routes.newPostgres}>
            Создать кластер PostgreSQL
          </Button>
        }
      />
    }
  />
);
